import PropTypes from "prop-types";
import { Box, Pagination, Stack, Typography } from "@mui/material";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

export default function CatalogTablePagination({
  rowsPerPage,
  setRowsPerPage,
  page,
  setPage,
  totalPages,
  countLabel,
  countValue,
  rowsOptions = [10, 25, 50, 100],
}) {
  return (
    <Box className="cm-pagination">
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography className="cm-pagination-label">Mostra:</Typography>
        <div className="cm-pagination-size-buttons" role="group" aria-label="Righe per pagina">
          {rowsOptions.map((size) => (
            <button
              key={`page-size-${size}`}
              type="button"
              className={`cm-btn cm-pagination-size-btn${rowsPerPage === size ? " is-active" : ""}`}
              title={typeof CM_TOOLTIPS.righePerPagina === "function" ? CM_TOOLTIPS.righePerPagina(size) : `Mostra ${size} righe per pagina`}
              onClick={() => {
                setRowsPerPage(size);
                setPage(0);
              }}
            >
              {size}
            </button>
          ))}
        </div>
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
        <Typography className="cm-pagination-label">{countLabel}:</Typography>
        <Typography className="cm-pagination-count">
          {Number(countValue || 0).toLocaleString("it-IT")}
        </Typography>
      </Stack>

      <Pagination
        count={totalPages || 1}
        page={page + 1}
        onChange={(_event, newPage) => setPage(newPage - 1)}
        shape="rounded"
        siblingCount={0}
        boundaryCount={1}
        size="small"
      />
    </Box>
  );
}

CatalogTablePagination.propTypes = {
  rowsPerPage: PropTypes.number.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  countLabel: PropTypes.string.isRequired,
  countValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowsOptions: PropTypes.arrayOf(PropTypes.number),
};
